import { Link } from "@StarberryUtils";
import React,{useEffect, useState} from "react";
import {Col, Row, Container, Tabs, Tab } from 'react-bootstrap';
import Loadable from "@loadable/component"
import  "./Similar.scss";
import Sale from './area-guide/sales';
import Let from './area-guide/lettings';
import Sold from './area-guide/sold';
import LetProp from './area-guide/let';

import { MenuPath } from "../../common/site/menu-path"

import { inViewOptions } from '../../utils/animations';
// import { motion } from "framer-motion";
// import { InView } from "react-intersection-observer";
const CommercialSales = Loadable(() => import("./area-guide/commercialSales"))
const CommercialLettings = Loadable(() => import("./area-guide/commercialLettings"))
const CommercialSold = Loadable(() => import("./area-guide/commercialSold"))
const CommercialLet = Loadable(() => import("./area-guide/commercialLet"))

const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.4,
      ease: [0.33, 1, 0.68, 1],
      duration: 0.4
    }
  }
}

const titleVariants = {
  hidden: {
    opacity: 0,
    y: 40 
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      ease: [0.33, 1, 0.68, 1],
      duration: 1
    }
  }
}

  const FeaturedProperties=(props)=>{

    const settings =  {
        dots: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        autoplay:true,
        
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }
      const settings2 = {
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        mobileFirst:true,
        
        responsive: [
          {
            breakpoint: 767,
             settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                    arrows: true,
                }
          },
          {
              breakpoint: 9999,
              settings: "unslick"
          }
          
      ]
      }
 const [key, setKey] = useState('sale');
 let url = MenuPath(props.page)

 useEffect(() => {
 if(url == "landlord" || url == "tenant") {
  setKey('rent')
 }
 else {
  setKey('sale')
 }
}, [])
      
  return(
    <>
        <section
          className="similar-sec featured-properties"
        >
          <Container>
            <div variants={titleVariants}>
              <h2 className="sec-title d-md-block">Featured Properties in {props.place}</h2>
            </div>
          <Tabs
            id="controlled-tab-example"
            activeKey={key}
            onSelect={(k) => setKey(k)}
          >
            <Tab eventKey={url == "landlord" || url == "tenant" ? 'rent' : 'sale'} title={url == "landlord" || url == "tenant" ? `Property to Rent` : `Property for Sale`}>
              


            <Row>
              <Col lg={12}>
                {url == "landlord" ?
                  <Let area={props.place} type={props.type} landtag={props.tag} ToLetData={props.ToLetData}/> :
                url == "tenant" ?
                <Let area={props.place} type={props.type} landtag={props.tag} ToLetData={props.ToLetData}/> :
                props?.Department == "commercial" ?
                  <CommercialSales  area={props.place} type={props.type} landtag={props.tag} SaleData={props.SaleData} Department={props.Department} />
                :
                  <Sale area={props.place} type={props.type} landtag={props.tag} SaleData={props.SaleData} />
                }
              </Col>
            </Row>



            </Tab>
            <Tab eventKey="sold" title="Sold Properties">
              


            <Row>
              <Col lg={12}>
                {props?.Department == "commercial" ?
                  <CommercialSold area={props.place} type={props.type} landtag={props.tag} SoldData={props.SoldData} Department={props.Department} />
                :
                  <Sold area={props.place} type={props.type} landtag={props.tag} SoldData={props.SoldData}/>
                }
                </Col>
            </Row>


            </Tab>
            <Tab eventKey={url == "landlord" || url == "tenant" ? 'sale' : 'rent'} title={url == "landlord" || url == "tenant" ? `Property for Sale` : `Property to Rent`}>


            <Row>
              <Col lg={12}>
              
              {url == "landlord" ?
                  <Sale area={props.place} type={props.type} landtag={props.tag} SaleData={props.SaleData}/> :
                url == "tenant" ?
                <Sale area={props.place} type={props.type} landtag={props.tag} SaleData={props.SaleData}/> :
                props?.Department == "commercial" ?
                  <CommercialLettings area={props.place} type={props.type} landtag={props.tag} ToLetData={props.ToLetData} Department={props.Department} />
                :
                <Let area={props.place} type={props.type} landtag={props.tag} ToLetData={props.ToLetData}/>
                }
              </Col>
            </Row>


            </Tab>

            <Tab eventKey="let" title="Let Properties">
              


            <Row>
              <Col lg={12}>
                {props?.Department == "commercial" ?
                  <CommercialLet area={props.place} type={props.type} landtag={props.tag} LetData={props.LetData} Department={props.Department} />
                :
                  <LetProp area={props.place} type={props.type} landtag={props.tag} LetData={props.LetData}/>
                }
              </Col>
            </Row>


            </Tab>
            {/* <Tab eventKey="let" title="Let Properties">
              


            <Row>
              <Col lg={12}>
              <Slider className="property-slider"  {...settings} >
                  {propOptions.map((item, index) => <div className="slide-item" key={index}>
                  <div className="similar-property-card d-md-flex flex-wrap"  >
                      <div className="view-part1">
                          <Slider className="main-slider" {...settings2} >
                              <div className="main-item">
                                  <img loading="lazy" src={item.mainImg} alt="Image" />
                                  <div className="on-map d-flex">
                                      <Link to="#"><i className="icon-location"></i> <span className="exp-txt text-uppercase">View on Map</span></Link>
                                      <Link to="#"><i className="icon-map-view"></i></Link>
                                  </div>
                              </div>
                              <div className="main-item d-md-none">
                                  <img loading="lazy" src={item.mainVideo} alt="Image" />
                                  <Link className="play-btn" to="#"><i className="icon-play-icon"></i></Link>
                              </div>
                              <div className="main-item d-md-none">
                                  <img loading="lazy" src={item.smallImg} alt="Image" />
                              </div>
                          </Slider>
                      </div>
                      <div className="card-details">
                          <div className="detail-head d-flex align-items-center justify-content-between">
                              <h2 className="price">&pound;{item.price}</h2>
                              <Link className="wishlist-icn" to="#"><i className="icon-heart"></i></Link>
                          </div> 
                          <span className="address-title d-block">{item.addLabel}</span>
                          <span className="prop-title d-block">5 bedroom detached house for sale</span>
                          <div className="d-flex">
                              <span className="distance d-flex align-items-center"><i className="icon-station"></i> 0.4 miles</span>
                              <span className="distance d-flex align-items-center"><i className="icon-schools"></i> 0.63 miles</span>
                          </div>
                      </div>
                  </div>
                  </div>
                  )
                  }
                  </Slider>
              </Col>
            </Row>


            </Tab> */}
            {props.page == "office" &&
            <Tab eventKey="valuation" title={<Link to="/market-your-property/book-a-valuation/" className="get-a-val-link">Get a Property Valuation</Link>}>
            </Tab>
            }
          </Tabs>

          </Container>
        </section>
      </>
  )
}

export default FeaturedProperties
